import {i18n} from 'src/shared/config'

export const translations = {
  title: i18n('banner.title.parcel-xxl', 'Доставка негабаритных вещей доступна только в кабинете для бизнеса'),
  description: i18n('banner.description.parcel-xxl', {fallBackToKey: false}),
  list: i18n('banner.list.parcel-xxl', {fallBackToKey: false}),
  imageSrc: i18n('banner.image-src.parcel-xxl', {fallBackToKey: false}),
}
